module.exports = __webpack_public_path__ + "static/img/produtos_p.a3afe4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/mate/produtos_p.png
// module id = mSJ0
// module chunks = 0